export const pl = {
  shell:{
    menu: 'Menu',
    exit: 'Wyjście',
    profile: 'Profil użytkownika',
    personalAccount: 'Konto użytkownika',
    developedBy: 'Developed by'
  },
  authentication: {
    authentication: 'Autoryzacja',
    registration: 'Rejestracja'
  },
  campaigns: {
    campaigns: 'Wysyałanie',
    dailyCampaigns: 'Aktywność dzienna',
    daily: 'Dzienne',
    dailyLabel: '└─Dzienne',
    campaign: 'Aktywność',
    newCampaign: 'Nowa wysyłka',
    campaignsArchive: 'Archiwum wysyłek',
    createCampaign: 'Utwórz wysyłkę',
    putCampaignsName: 'Wpisz nazwę wysyłki',
    ringing: 'Dzwonienie',
    report: 'Raport',
    unprocessed: 'Nie przetworzone',
    monitoring: 'Monitorowanie',
    cost: 'Koszt',
    toArchive: 'Do archiwum',
    loadBase: 'Wczytywanie bazy',
    putBaseFromClipboard: 'Wklej bazę ze schowka',
    deleteFailedCalls: 'Usuń nieudane połączenia',
    reportTexts: {
      createReport: 'Utwórz raport',
      reportIsBeingGeneratedNow: 'Raport jest generowany',
      createReportError: 'Błąd podczas tworzenia raportu'
    },
    states: {
      started: 'W toku',
      readyToRun: 'Gotowe do uruchomienia',
      preparing: 'W przygotowaniu',
      ready: 'Gotowe',
      finished: 'Zakończone',
      paused: 'Zatrzymane',
      canceled: 'Anulowane'
    },
    campaignParams: {
      campaignsParameters: 'Parametry wysyłki',
      callDate: 'Data połączeń',
      putCallDate: 'Wprowadź datę',
      timezone: 'Strefa czasowa UTC',
      callTime: 'Godziny połączeń',

      numberOfAttemptsToGetThrough: 'Liczba prób połączeń',
      intervalBetweenRepeatedCalls: 'Przerwa między kolejnymi próbami połączeń (minuty)',
      openScenario: 'Otwórz scenariusz',
      scenarioIsReady: 'Scenariusz gotowy',
      scenarioIsNotReady: 'Scenariusz nie gotowy',

      base: 'Baza',
      viewBase: 'Przegladaj bazę',
      removeBase: 'Usuń bazę',
      numbers: 'Numery',
      uploadedNumbers: 'Wczytano numery',
      reportByTestCalls: 'Raport z połączenia testowego',

      callResult: 'Rezultat połączeń',
      callsMonitoring: 'Monitoring połączeń'
    },
    additionalParameters: {
      additionalParameters: 'Dodatkowe parametry'
    },
    quotas: {
      quotas: 'Kwota',
      noLimit: 'Bez limitu',
      addQuota: 'Dodaj kwotę'
    }
  },
  testCall: {
    call: 'Połączenie',
    testCall: 'Połączenie testowe',
    callToNumber: 'Zadzwoń pod numer',
    putNumber: 'Wprowadź numer',
    viewTestResults: 'Wyświetl wyniki testu',
    testCallParameters: 'Parametry połączenia testowego',
    callToPhone: 'Połączenie z telefonem',
    calInBrowser: 'Połączenie w przeglądarce'
  },
  scenarios: {
    scenarios: 'Scenariusze',
    scenario: 'Scenariusz',
    createScenario: 'Utwórz scenariusz',
    newScenario: 'Nowy scenariusz',
    scenarioName: 'Nazwa scenariusza',
    putScenarioName: 'Wprowadź nazwę scenariusza',
    prepared: 'Gotowe',
    notPrepared: 'Nie gotowe',
    scenarioTemplate: 'Szablon scenariusza',

    chooseScenarioTemplate: 'Wybierz szablon scenariusza',
    konstruktor: {
        toolButtons: {
          testCall: 'Połączenie testowe',
          callToNumber: 'Połącz z numerem'
        },
        commonParams: {
          hideArrows: 'Ukryj strzałki'
        },
        canvas: {
          add: {
            robotAnswer: 'odpowiedź robota',
            recognition: 'rozpoznawanie',
            redirectToOperator: 'Dodaj przekierowanie do operatora',
            sendSMS: 'Wyślij SMS',
            sendHttpRequest: 'Wyślij żądanie http'
          },
          answer: {
            answer: 'Odpowiedź',
            startOfTalk: 'Początek rozmowy',
            stateQuestion: 'Status zapytania',
            silence: 'Cisza',
            illegibly: 'Nieczytelne',
            approve: 'Dobrze',
            deny: 'Negacja',
            custom: 'Indywidualny',
            anotherAnswer: 'Inna odpowiedź',
            foStatusValueUse: 'Dla podkreślenia stanu użyj',
            transcription: 'Transkrypcja',
            indicate: 'Wskaż',
            stateValue: 'Status zapytania',
            windowSizes: {
              smallSize: 'Mały rozmiar',
              mediumSize: 'Średni rozmiar',
              maxSize: 'Duży rozmiar'
            },
            synonyms: {
              addForAllWithSameTitle: 'Dodaj wszędzie , gdzie jest taka nazwa',
              addWord: 'Dodaj słowo lub frazę'
            },
            initAudio: {
              fromText: 'Z tekstu',
              toPutUrl: 'Wprowadź z URL',
              putUrl: 'Wprowadź adres URL',
              toAddUrl: 'Dodaj adres URL',
              toRemoveUrl: 'Usuń adres URL',

              toUploadFromFile: 'Wczytaj z pliku',
              toRemoveAll: 'Usuń wszystko',

              toAddParameter: 'Dodaj parametr',
              putParameterName: 'Wprowadź nazwę parametru',
              addParameter: 'Dodaj parametr',
              toRemoveParameter: 'Usuń parametr',
              speed: 'Prędkość',
              generateAudio: 'Generuj dzwięk',

              Your_browser_does_not_support_html5_audio_Try_chrome: 'Twoja przeglądarka nie obsługuje html5 audio. Spróbuj użyć Chrome.'
            },
            audioConfig: 'Konfiguracja audio',
            sipSubUrl: 'Adres SIP',
            sms: {
              gateway: 'Bramka',
              sender: 'Nadawca',
              messageText: 'Treść wiadomości'
            },
            httpRequest: {
              params: 'Parametry',
              headers: 'Headers',
              body: 'Body'
            }
          }
      },
      removeScenario: 'Usuń scenariusz'
    }
  },
  users: {
    users: 'Użytkownicy',
    user: 'Użytkownik',
    newUser: 'Nowy użytkownik',
    userData: 'Dane użytkownika'
  },
  callTasks: {
    testCallsByCampaign: 'Тестовые звонки по рассылке',
    phone: 'Telefon',
    state: 'Состояние',
    phoneNumber: 'Numer telefonu',
    byCampaign: 'по рассылке',
    states: {
      'failed': 'Недозвон',
      'dialing': 'Połączenie',
      'ongoing': 'Jest rozmowa',
      'performed': 'Gotowy',
      'postponed': 'Opóźniony',
      'ready': 'Kolejka',
      'telephony_error_suspend': 'Opóźniony',
      'canceled': 'Anulowany'
    }
  },
  permissions: {
    permissions: 'Uprawnienia'
  },
  appConfig: {
    appConfig: 'Ustawienia aplikacji'
  },
  common: {
    yes: 'Tak',
    no: 'Nie',
    timeInterval:{
      from: 'od',
      to: 'do'
    },
    search: 'Szukaj',
    title: 'Nazwa',
    client: 'Klient',
    template: 'Szablon',
    readiness: 'Gotowość',
    state: 'Status',
    creationDate: 'Data utworzenia',
    up: 'na górę',
    settings: 'Ustawienia',
    action: 'Czynność',
    actions: {
      add: 'Dodaj',
      delete: 'Usuń',
      save: 'Zapisz',
      cancel: 'Anuluj',
      close: 'Zamknij',
      connect: 'Połącz',
      run: 'Uruchom',
      stop: 'Zatrzymaj',
      copy: 'Kopiuj',
      load: 'Wczytaj',
      loadFromFile: 'Wczytaj z pliku',
      create: 'Utwórz',
      reCreate: 'Utwórz ponownie'
    },
    key: 'Klucz',
    parameter: 'Parametr',
    value: 'Wartość',
    language: 'Język',
    voice: 'Głos',
    time: {
      minutes: 'minuty',
      seconds: 'sekundy'
    },
    date: {
      days: {
        longhand: {
          sunday: 'niedziela',
          monday: 'poniedziałek',
          tuesday: 'wtorek',
          wednesday: 'środa',
          thursday:  'czwartek',
          friday:  'piątek',
          saturday: 'sobota'
        },
        shorthand: {
          sunday: 'niedz.',
          monday:  'pon.',
          tuesday:  'wt.',
          wednesday:  'śr.',
          thursday: 'czw.',
          friday: 'pt.',
          saturday: 'sob.'
        }
      },
      months: {
        January : 'styczeń',
        February:  'luty',
        March: 'larzec',
        April:  'kwiecień',
        May:  'maj',
        June: 'czerwiec',
        July:  'lipiec',
        August:  'sierpień',
        September:  'wrzesień',
        October: 'październik',
        November: 'listopad',
        December: 'grudzień'
      }
    },
    results: 'Wyniki',
    recognitionLogs: 'Dzienniki rozpoznawania',
    information: 'Informacja'
  },
  paging: {
    first: 'Pierwsza',
    previous: 'Poprzednia',
    next:  'Następna',
    last:  'Ostatnia'
  },
  errors: {
    downloadError: 'Błąd pobierania'
  },
  notifications: {
    notification: 'Powiadomienia',
    toAddRobotAnswerPleaseRemoveRedirectToOperator: 'Aby dodać odpowiedź robota, usuń przekierowanie do operatora',
    toAddRedirectToOperatorPleaseRemoveAllRobotAnswers: 'Aby dodać przekierowanie do operatora usuń wszystkie odpowiedzi robota',

    thereIsAlreadyHasARedirectToOperator: 'Istnieje już przekierowanie do operatora',

    errorLoadApplicationConfig: 'Błąd wczytywania ustawień aplikacji',
    errorLoadAudio: 'Błąd wczytywania dzwięku',

    beforeGenerateAudioYouShouldSaveScenario: 'Przed wygenerowaniem audio, zapisz scenariusz',

    beforeUploadFileYouShouldSaveScenario: 'Przed pobraniem pliku, zapisz scenariusz',

    beforeLoadAudioYouShouldSaveScenario: 'Przed pobraniem audio, zapisz scenariusz',

    campaign: {
      campaignIsReady: 'Рассылка подготовлена',
      errorStartCampaign: 'Ошибка запуска рассылки',
      campaignStopped: 'Рассылка остановлена',
      errorStopCampaign: 'Ошибка остановки рассылки',
      report: {
        errorLoadReport: 'Ошибка загрузки отчета'
      },
      errorDeletePhoneBase: 'Ошибка удаления телефонной базы',
      baseRemoved: 'База удалена'
    },

    scenario: {
      scenarioHasBeenRemoved: 'Scenariusz usunięty',

      errorRemoveScenario: 'Błąd usuwania scenariusza',
      errorToGetUserStatus: 'Błąd wczytywania statusu użytkownika',
      errorLoadScenarioList: 'Błąd wczytywania listy scenariuszy',
      errorLoadScenario: 'Błąd wczytywania scenariusza',

      scenarioSaved: 'Scenariusz zapisany',
      errorSaveScenario: 'Błąd zapisu scenariusza'
    },
    testCall: {
      testCallActivated: 'Uruchomiono połączenie testowe',
      errorCreatingTestCall: 'Błąd uruchamiania połączenia testowego',
      testCallNumberSaved: 'Номер тестового звонка сохранен',
      saveCampaignBeforeTestCall: 'Перед тестом необходимо сохранить рассылку'
    },
    callTasks: {
      errorLoadTestCallsPhoneNumbers: 'Ошибка загрузки тестовых телефонных номеров'
    }
  }
}



// WEBPACK FOOTER //
// ./client/translations/pl.js